<div class="modal-div">
    <div class="modal-header" name="modal-dialog">
      <h4 class="modal-title" translate>{{titolo}}</h4>
      <button type="button" class="close modale" aria-label="Chiudi" (click)="chiudi()">
        <span>&times;</span>
      </button>
    </div>
    <div class="modal-body">
      <p translate>{{messaggio}}</p>
    </div>
    <div class="modal-footer">
      <button type="button" class="btn btn-primary modale" id="btn-confirm-offer" (click)="confirm()"><span translate>popup.conferma</span></button>
      <button type="button" class="btn btn-default modale" (click)="chiudi()"><span translate>popup.chiudi</span></button>
    </div>
</div>